module.exports = {
  dimensions: {
    width: 399,
    height: 65
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};